import { render, staticRenderFns } from "./CommunityRedirectCard.vue?vue&type=template&id=5023ada9"
import script from "./CommunityRedirectCard.vue?vue&type=script&lang=js"
export * from "./CommunityRedirectCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports